import { Routes, RouterModule } from '@angular/router';
import { AccountOwnerComponent } from './account-owner/account-owner.component';
import { AccountOwnerDetailsComponent } from './account-owner-details/account-owner-details.component';
import { EditAccountComponent } from './edit-account/edit-account.component';
import { ChangePlanOwnerComponent } from './change-plan-owner/change-plan-owner.component';
import { PaymentMethodsComponent } from './payment-methods/payment-methods.component';
import { EditCardComponent } from './payment-methods/edit-card/edit-card.component';
import { NgModule } from '@angular/core';
import { SubscriptionDetailsComponent } from './subscription-details/subscription-details.component';
import { ViewReceiptComponent } from './subscription-details/view-receipt/view-receipt.component';
import { SubscriptionPurchaseComponent } from './subscription-purchase/subscription-purchase.component';
import { ChangePlanProrateComponent } from './change-plan-prorate/change-plan-prorate.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { UpdateLogoComponent } from './update-logo/update-logo.component';

const routes: Routes = [
    {
      path: '',
      component: AccountOwnerComponent,
      canActivate: [AuthGuard],
      children: [
        {
          path: '',
          data: {
            breadcrumb: 'account'
          },
          component: AccountOwnerDetailsComponent,
          canActivate: [AuthGuard]
        },
        {
          path: 'change-plan-prorate',
          children: [
            {
              path: '',
              component: ChangePlanProrateComponent,
              data: { breadcrumb: 'change-plan-prorate' },
              canActivate: [AuthGuard]
            },
            {
              path: 'payment-methods',
              canActivate: [AuthGuard],
              children: [
                {
                  path:'',
                  data: {
                    breadcrumb: 'payment-methods'
                  },
                  component: PaymentMethodsComponent,
                  canActivate: [AuthGuard]
                },
                {
                  path: 'edit-card/:cardId',
                  component: EditCardComponent,
                  data: {
                    breadcrumb: 'edit-card'
                  },
                  canActivate: [AuthGuard]
                }
              ]
            },
          ]
        },
        {
          path: 'edit-account',
          component: EditAccountComponent,
          data: { breadcrumb: 'edit-account' },
          canActivate: [AuthGuard]
        },
        {
          path: 'edit-picture',
          component: UpdateLogoComponent,
          data: { breadcrumb: 'edit-org-picture' },
          canActivate: [AuthGuard]
        },
        {
          path: 'subscription-purchase',
          canActivate: [AuthGuard],
          children: [
            {
              path: '',
              component: SubscriptionPurchaseComponent,
              data: { breadcrumb: 'subscription-purchase' },
              canActivate: [AuthGuard]
            },
            {
              path: 'payment-methods',
              children: [
                {
                  path:'',
                  data: {
                    breadcrumb: 'payment-methods'
                  },
                  component: PaymentMethodsComponent,
                  canActivate: [AuthGuard]
                },
                {
                  path: 'edit-card/:cardId',
                  component: EditCardComponent,
                  data: {
                    breadcrumb: 'edit-card'
                  },
                  canActivate: [AuthGuard]
                }
              ]
            },
          ]
        },
        {
          path: 'subscription-details',
          canActivate: [AuthGuard],
          children: [
            {
              path: '',
              data: {
                breadcrumb: 'subscription-details'
              },
              component: SubscriptionDetailsComponent,
              canActivate: [AuthGuard]
            },
            {
              path: 'subscription-purchase',
              children: [
                {
                  path:'',
                  component: SubscriptionPurchaseComponent,
                  data: { breadcrumb: 'subscription-purchase' },
                  canActivate: [AuthGuard]
                },
                {
                  path:'payment-methods',
                  children: [
                    {
                      path:'',
                      data: {
                        breadcrumb: 'payment-methods'
                      },
                      component: PaymentMethodsComponent,
                      canActivate: [AuthGuard]
                    },
                    {
                      path: 'edit-card/:cardId',
                      component: EditCardComponent,
                      data: {
                        breadcrumb: 'edit-card'
                      },
                      canActivate: [AuthGuard]
                    }
                  ]
                }
              ]
            },
            {
              path: 'view-receipt/:paymentId',
              component: ViewReceiptComponent,
              data: { breadcrumb: 'view-receipt' },
              canActivate: [AuthGuard]
            }
          ]
        },
        {
          path: 'payment-methods',
          canActivate: [AuthGuard],
          children: [
            {
              path: '',
              data: {
                breadcrumb: 'payment-methods'
              },
              component: PaymentMethodsComponent,
              canActivate: [AuthGuard]
            },
            {
              path: 'edit-card/:cardId',
              component: EditCardComponent,
              data: {
                breadcrumb: 'edit-card'
              },
              canActivate: [AuthGuard]
            }
          ]
        },
        
      ]
    }
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class AccountOwnerRoutingModule {}
  export const ACCOUNT_OWNER_ROUTE_COMPONENTS = [
    ChangePlanOwnerComponent,
    EditAccountComponent
  ];